import { render } from "./FormDatamodel.vue?vue&type=template&id=49785b04&scoped=true&ts=true"
import script from "./FormDatamodel.vue?vue&type=script&lang=ts"
export * from "./FormDatamodel.vue?vue&type=script&lang=ts"

import "./FormDatamodel.vue?vue&type=style&index=0&id=49785b04&lang=scss&scoped=true"
import "./FormDatamodel.vue?vue&type=style&index=1&id=49785b04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49785b04"]])

export default __exports__